import { Theme, styled } from '@material-ui/core';

const Prefix = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.primaryFontFamily,
  fontSize: theme.typography.h4.fontSize,
  fontWeight: 400,
  color: theme.palette.primary.main,
}));

export default Prefix;
